// extracted by mini-css-extract-plugin
export var link = "legal-module--link--e5d0e link-module--linkInverse--0b597";
export var wrapper = "legal-module--wrapper--1caa1";